import { render, staticRenderFns } from "./PartnerPortalRedirect.vue?vue&type=template&id=0a343c94&scoped=true"
import script from "./PartnerPortalRedirect.vue?vue&type=script&lang=ts"
export * from "./PartnerPortalRedirect.vue?vue&type=script&lang=ts"
import style0 from "./PartnerPortalRedirect.vue?vue&type=style&index=0&id=0a343c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a343c94",
  null
  
)

export default component.exports